"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWarningObject = exports.createUnusableObject = void 0;
function createUnusableObject(message) {
    const handle = () => {
        throw new Error(message);
    };
    return new Proxy({}, {
        apply: handle,
        construct: handle,
        defineProperty: handle,
        deleteProperty: handle,
        get: handle,
        getOwnPropertyDescriptor: handle,
        getPrototypeOf: handle,
        has: handle,
        isExtensible: handle,
        ownKeys: handle,
        preventExtensions: handle,
        set: handle,
        setPrototypeOf: handle
    });
}
exports.createUnusableObject = createUnusableObject;
function createWarningObject(message, obj) {
    return new Proxy(obj, {
        get: (...args) => {
            // eslint-disable-next-line no-console
            console.warn(message);
            return Reflect.get(...args);
        },
        set: (...args) => {
            // eslint-disable-next-line no-console
            console.warn(message);
            return Reflect.set(...args);
        },
        getOwnPropertyDescriptor: (...args) => {
            // eslint-disable-next-line no-console
            console.warn(message);
            return Reflect.getOwnPropertyDescriptor(...args);
        },
        ownKeys: (...args) => {
            // eslint-disable-next-line no-console
            console.warn(message);
            return Reflect.ownKeys(...args);
        }
    });
}
exports.createWarningObject = createWarningObject;
